import { render, staticRenderFns } from "./RestQuestionCount.vue?vue&type=template&id=e60e0126&scoped=true&"
import script from "./RestQuestionCount.ts?vue&type=script&lang=ts&"
export * from "./RestQuestionCount.ts?vue&type=script&lang=ts&"
import style0 from "./RestQuestionCount.css?vue&type=style&index=0&id=e60e0126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e60e0126",
  null
  
)

export default component.exports